import t from "../../../helpers/t";
import React from "react";
import Biscuit from "../../../../utils/Biscuit";

export const CheckinsProgressBar = (props) => {
    const { hasCompletedCheckouts, hasFutureCheckout, hasFutureCheckin, hasValidCheckin, _exchangeLabel } = props;
    let widthSet = "105%";
    if((hasCompletedCheckouts && !hasFutureCheckin && !hasFutureCheckout) || (!hasCompletedCheckouts && hasValidCheckin) || (hasFutureCheckin)){
        widthSet = "120%";
    }
    return(
        <>
            <div className={"inb-contingent-progress hide-for-small-only" + (hasCompletedCheckouts && !hasFutureCheckin && !hasFutureCheckout ? ' has-checkout' : '')}
                 style={{marginBottom: "-1rem"}}>
                <div className={"progress beautify beautify-"+ Biscuit.get('user.client_id')} role="progressbar" tabIndex="0">
                    {((!hasCompletedCheckouts && !hasValidCheckin && !hasFutureCheckin) || (hasFutureCheckout && !hasFutureCheckin && hasCompletedCheckouts && !hasValidCheckin)) &&
                    <>
                        <div className="progress-bars">
                            <span className="progress-meter" style={{width: "0%"}}> </span>
                        </div>
                        <p className="progress-meter-text">
                            {t(_exchangeLabel('inprogress_ext'))}
                        </p>
                    </>
                    }
                    {hasCompletedCheckouts && !hasFutureCheckin && !hasFutureCheckout &&
                    <>
                        <div className="progress-bars">
                            <span className="progress-meter" style={{width: "100%", background: "#acb9d3"}}> </span>
                        </div>
                        <p className="progress-meter-text">
                            <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                            {t('checkout_finished')}
                        </p>
                    </>
                    }
                    {!hasCompletedCheckouts && hasValidCheckin &&
                    <>
                        <div className="progress-bars">
                            <span className="progress-meter" style={{width: "100%", background: "#acb9d3"}}> </span>
                        </div>
                        <p className="progress-meter-text">
                            <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                            {t('rental_aborted_by_user')}
                        </p>
                    </>
                    }
                    {hasFutureCheckin &&
                        <>
                            <div className="progress-bars">
                                <span className="progress-meter" style={{width: "100%", background: "#acb9d3"}}> </span>
                            </div>
                            <p className="progress-meter-text">
                                <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                                {t('confirmed')}
                            </p>
                        </>
                    }
                </div>
            </div>


            <div className={"inb-contingent-progress show-for-small-only" + (hasCompletedCheckouts && !hasFutureCheckin && !hasFutureCheckout ? ' has-checkout' : '')}
                 >
                <div className={"progress beautify beautify-"+ Biscuit.get('user.client_id')} role="progressbar" tabIndex="0">
                    {((!hasCompletedCheckouts && !hasValidCheckin && !hasFutureCheckin) || (hasFutureCheckout && !hasFutureCheckin && hasCompletedCheckouts && !hasValidCheckin)) &&
                        <>
                            <div className="progress-bars">
                                <span className="progress-meter" style={{width: "0%"}}> </span>
                            </div>
                            <p className="progress-meter-text">
                                {t(_exchangeLabel('inprogress_ext'))}
                            </p>
                        </>
                    }
                    {hasCompletedCheckouts && !hasFutureCheckin && !hasFutureCheckout &&
                        <>
                            <div className="progress-bars">
                                <span className="progress-meter" style={{width: "105%", background: "#acb9d3"}}> </span>
                            </div>
                            <p className="progress-meter-text">
                                <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                                {t('checkout_finished')}
                            </p>
                        </>
                    }
                    {!hasCompletedCheckouts && hasValidCheckin &&
                        <>
                            <div className="progress-bars">
                                <span className="progress-meter" style={{width: "105%", background: "#acb9d3"}}> </span>
                            </div>
                            <p className="progress-meter-text">
                                <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                                {t('rental_aborted_by_user')}
                            </p>
                        </>
                    }
                    {hasFutureCheckin &&
                        <>
                            <div className="progress-bars">
                                <span className="progress-meter" style={{width: "105%", background: "#acb9d3"}}> </span>
                            </div>
                            <p className="progress-meter-text">
                                <i className="fi fi-check" style={{fontSize: "0.8rem"}}> </i>
                                {t('confirmed')}
                            </p>
                        </>
                    }
                </div>
            </div>
        </>
    )
}